import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en_US from '../config/lang/en_US'
import de_DE from '../config/lang/de_DE'
import bg_BG from '../config/lang/bg_BG'
import sv_SE from '../config/lang/sv_SE'

Vue.use(VueI18n)

const messages = {
  'en_US.UTF-8': en_US,
  'de_DE.UTF-8': de_DE,
  'bg_BG.UTF-8': bg_BG,
  // 'ru_RU.UTF-8': ru_RU,
  // 'fr_FR.UTF-8': fr_FR,
  'sv_SE.UTF-8': sv_SE
}

const i18n = new VueI18n({
  locale: 'en_US.UTF-8', // set locale
  fallbackLocale: 'en_US.UTF-8', // set fallback locale
  messages, // set locale messages
})

export default i18n
